import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { DialogService } from '../../../services/dialog/dialog.service';
import { AnalysisService } from '../../../services/analysis.service';
import { Company } from '../../models/company/company';

@Component({
  selector: 'psc-company-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, SharedModule, TranslocoModule],
  templateUrl: './company-card.component.html',
})
export class CompanyCardComponent implements OnChanges {

  @Input() company: Company;

  infoArray: { icon: string, value: string }[] = [];

  constructor(
    private dialogService: DialogService,
    private analysisService: AnalysisService,
  ) {
  }

  ngOnChanges(): void {
    this.infoArray = [
      { icon: 'location_on', value: this.company.address },
      { icon: 'mail', value: this.company.email },
      { icon: 'language', value: this.company.website },
      { icon: 'call', value: this.company.tel },
    ];
  }


}
